import * as React from "react";
import { animate } from "motion";

type Props = {
  to: number;
  from?: number;
  duration?: number;
  format?: (n: number) => string;
  className?: string;
};

/**
 * Count-up driven by Motion One (motion package). Triggers when the element
 * scrolls into view via IntersectionObserver.
 */
export function CountUp({ to, from = 0, duration = 1.6, format, className }: Props) {
  const ref = React.useRef<HTMLSpanElement>(null);
  const fired = React.useRef(false);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      entries => {
        for (const e of entries) {
          if (e.isIntersecting && !fired.current) {
            fired.current = true;
            const obj = { v: from };
            animate(from, to, {
              duration,
              ease: [0.22, 1, 0.36, 1] as any,
              onUpdate: (v) => {
                obj.v = v;
                if (el) el.textContent = format ? format(v) : Math.round(v).toLocaleString();
              }
            });
          }
        }
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [from, to, duration, format]);

  return <span ref={ref} className={className}>{format ? format(from) : from.toLocaleString()}</span>;
}
